import { render, staticRenderFns } from "./order-form.vue?vue&type=template&id=57ef1cb6&scoped=true"
import script from "./order-form.vue?vue&type=script&lang=js"
export * from "./order-form.vue?vue&type=script&lang=js"
import style0 from "./order-form.vue?vue&type=style&index=0&id=57ef1cb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ef1cb6",
  null
  
)

export default component.exports